import API from "./API";

// Look up an Indian PIN code and auto-fill the address boxes from it.
//
// This lived as a private copy inside remitters/RemitterForm.js, which is why the
// transaction form never had it - the master remitter screen filled the address and
// the identical boxes on the Entity Details step did nothing. It is shared now so a
// screen gains the behaviour by passing afterBlur, not by copying the function.
//
// Only boxes the form actually has are written to: the accountant screens carry no
// post office field, and setting one there would put a value in the payload that the
// form never shows and the CA cannot correct.
const PINCODE_FIELDS = ['area_locality', 'town_city_district', 'state', 'post_office', 'country'];

export default async function fillAddressFromPincode(pincode, formik, prefix = '') {
    const pin = (pincode || '').trim();
    // The accountant master screen passes formikRef.current, which is null until the
    // form mounts.
    if (!formik || !/^\d{6}$/.test(pin)) return;
    try {
        const {data} = await API.get(`pincode/${pin}/`);
        if (!data || !data.found) return;
        for (const field of PINCODE_FIELDS) {
            if (data[field] === undefined) continue;
            const name = `${prefix}${field}`;
            if (formik.values && !(field in formik.values)) continue;
            formik.setFieldValue(name, data[field]);
        }
    } catch (e) {
        // The lookup is a convenience. On any error the CA fills the address by hand,
        // which is what happened on every screen but one until now.
    }
}
